/** Joins truthy class names: cx("btn", active && "active") → "btn active". */
export const cx = (...parts: (string | false | null | undefined)[]) => parts.filter(Boolean).join(" ");
